<!--
  UpdateFloatBtn.vue
    更新ボタン Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
  <div class="hm-display-mobile">
  <v-fab-transition>
    <v-btn
      class="mr-2 hm-update-float-btn"
      absolute
      color="blue lighten-1"
      dark
      top
      right
      fab
      v-show="mVisible"
      @click="updateStatus"
    >
      <v-icon>send</v-icon>
    </v-btn>
  </v-fab-transition>
  </div>
  <div class="hm-display-monitor">
  <v-fab-transition>
    <v-btn
      class="mr-2 hm-update-float-btn"
      absolute
      color="blue lighten-1"
      dark
      top
      right
      fab
      v-show="mVisible"
      @click="updateStatus"
    >
      <v-icon>send</v-icon>
    </v-btn>
  </v-fab-transition>
  </div>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'

export default {
  name: 'UpdateFloatBtn',
  data: () => ({
    // nothing
  }),
  mounted: function () {
    this.$log.debug('# UpdateFloatBtn')
  },
  destroyed: function () {
    this.$log.debug('# UpdateFloatBtn')
  },
  computed: {
    ...mapState({
      mVisible: state => state.sUpbtnVisible
    }),
  },
  methods: {
    updateStatus: function () {
      this.$emit('updateWhereabouts')
      //this.$store.commit('setUpbtnVisible', false)
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-update-float-btn-wrap {
  margin-top: 20px;
}
.hm-update-float-btn {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/UpdateFloatBtn.vue